import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Header from './layout/Header'
import Footer from './layout/Footer'
import * as websiteService from './services/website.services'
import { autoHyperlinkHtml } from '../../utils/commonfunction'
import './Home.css'

function DynamicCMSPage() {
    const { slug } = useParams();
    const [cmsData, setCmsData] = useState(null);

    useEffect(() => {
        const fetchCms = async () => {
            try {
                // Clear previous data when slug changes
                setCmsData(null);
                const response = await websiteService.CMSPage(slug);
                if (response.success) {
                    setCmsData(response.data);
                }
            } catch (error) {
                console.error(`Failed to fetch CMS content for slug: ${slug}`, error);
            }
        };
        if (slug) {
            fetchCms();
        }
    }, [slug]);

    return (
        <React.Fragment>
            <Header />
            <main className="cms-page-content">
                <section className="padding-top-100 padding-bottom-100">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                {cmsData ? (
                                    <div className="cms-copy">
                                        <h1 className="cms-title mb-4">{cmsData.title}</h1>
                                        <div 
                                            className="cms-description" 
                                            dangerouslySetInnerHTML={{ __html: autoHyperlinkHtml(cmsData.description) }} 
                                        />
                                    </div>
                                ) : (
                                    <div className="text-center">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </React.Fragment>
    )
}

export default DynamicCMSPage
